export const SENTRY_RELEASE: string | undefined = 'd4e2b770372e30305aa55e022738d2bf6254cfcc';
